<template>
  <div id="appNavbar" class="header">
    <ServerError v-if="ServerError" />
    <v-navigation-drawer v-model="sideNav" fixed temporary>
      <v-list-item-content class="hidden-md-and-up">
        <v-list v-if="!appLogin" dense>
          <v-list-item v-for="item in guestNav" :key="item.name" link>
            <v-list-item-icon>
              <v-icon style="color:#1fb07c;">{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <router-link :to="item.route">
                <v-list-item-title style="color:#1fb07c;">{{ item.name }}</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-if="appLogin" dense>
          <v-list-item v-for="item in investorNavMob" :key="item.name" link>
            <v-list-item-icon>
              <v-icon style="color:#1fb07c;">{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <router-link :to="item.route">
                <v-list-item-title style="color:#1fb07c;">{{ item.name }}</v-list-item-title>
              </router-link>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon style="color:#1fb07c;">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title @click="appLogout" style="color:#1fb07c;">LOGOUT</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item-content>
    </v-navigation-drawer>
    <v-app-bar app color="#1fb07c" dark dense flat>
      <!-- <v-toolbar color="#1fb07c" dark height="50px" elevation="0"> -->
      <v-app-bar-nav-icon @click.native="sideNav = !sideNav" class="hidden-md-and-up"></v-app-bar-nav-icon>
      <v-toolbar-title pl-12>
        <router-link to="/">
          <span class="AppHeading">ECOSYSTEM INVESTOR PLATFORM</span>
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items
        v-for="(item,i) in mainNav"
        v-bind:key="i"
        class="nav_item hidden-sm-and-down"
      >
        <v-row justify-center>
          <router-link :to="item.route">
            <v-btn text :ripple="false" color="white" class="nav_item AppMenu">{{item.name}}</v-btn>
          </router-link>
        </v-row>
      </v-toolbar-items>

      <v-toolbar-items v-if="!appLogin" class="nav_item hidden-sm-and-down">
        <!-- <v-row justify="center"> -->
        <router-link to="/Login">
          <v-btn text :ripple="false" class="nav_item AppMenu">LOG IN</v-btn>
        </router-link>
        <router-link to="/Signup">
          <v-btn
            text
            :ripple="false"
            class="nav_item AppMenu"
            style="background-color: #38B98A!important;"
          >SIGN UP</v-btn>
        </router-link>
        <v-spacer></v-spacer>
        <!-- </v-row> -->
      </v-toolbar-items>
      <v-toolbar-items v-else class="nav_item hidden-sm-and-down">
        <v-row justify="center">
          <v-menu
            :close-on-content-click="false"
            :nudge-bottom="40"
            :nudge-right="50"
            transition="slide-y-transition"
            style="padding-top:40px;"
            bottom
            dark
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                :ripple="false"
                class="nav_item AppMenu"
                style="background-color: #38B98A!important;"
                v-on="on"
              >
                <v-avatar v-if="profilePic" height="25" width="25">
                  <!-- <v-img :src="baseURL+'/u/'+profilePic" aspect-ratio="1" cover >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>-->
                  <img :src="baseURL+'/u/'+profilePic" />
                </v-avatar>
                {{userName}}
              </v-btn>
            </template>
            <v-card width="150">
              <v-layout pa-3>
                <v-flex>
                  <router-link to="/Profile">
                    <v-layout style="cursor:pointer;">
                      <v-flex text-left>
                        <span style="font-size:12px;color:white">Profile</span>
                      </v-flex>
                      <v-flex text-right>
                        <v-icon style="font-size:14px;">mdi-account</v-icon>
                      </v-flex>
                    </v-layout>
                  </router-link>
                  <v-divider></v-divider>
                  <router-link to="/Settings">
                    <v-layout style="cursor:pointer;">
                      <v-flex text-left>
                        <span style="font-size:12px;color:white">Settings</span>
                      </v-flex>
                      <v-flex text-right>
                        <v-icon style="font-size:14px;">mdi-wrench</v-icon>
                      </v-flex>
                    </v-layout>
                  </router-link>
                  <v-divider></v-divider>
                  <v-layout @click="appLogout" style="cursor:pointer;">
                    <v-flex text-left>
                      <span style="font-size:12px;">Sign Out</span>
                    </v-flex>
                    <v-flex text-right>
                      <v-icon style="font-size:14px;">mdi-logout</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-menu>
          <v-spacer></v-spacer>
        </v-row>
      </v-toolbar-items>
      <!-- </v-toolbar> -->
    </v-app-bar>
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";
export default {
  data() {
    return {
      ServerError: false,
      menu: false,
      guestNav: [
        { name: "HOME", route: "/", icon: "mdi-home" },
        {
          name: "PROJECT STATUS",
          route: "/ProjectStatus",
          icon: "mdi-bookmark"
        },
        { name: "RESOURCES", route: "/Resources", icon: "mdi-cloud" },
        { name: "ABOUT US", route: "/AboutUs", icon: "mdi-note-text" },
        { name: "LOGIN", route: "/Login", icon: "mdi-login" },
        { name: "SIGNUP", route: "/Signup", icon: "mdi-lead-pencil" }
      ],
      investorNavMob: [
        { name: "HOME", route: "/", icon: "mdi-home" },
        {
          name: "PROJECT STATUS",
          route: "/ProjectStatus",
          icon: "mdi-bookmark"
        },
        { name: "RESOURCES", route: "/Resources", icon: "mdi-cloud" },
        { name: "ABOUT US", route: "/AboutUs", icon: "mdi-note-text" },
        { name: "PROFILE", route: "/Profile", icon: "mdi-account" },
        { name: "SETTINGS", route: "/Settings", icon: "mdi-wrench" }
        // { name: "LOGOUT", route: "/" }
      ],
      mainNav: [
        { name: "HOME", route: "/", icon: "mdi-home", type: "both" },
        {
          name: "PROJECT STATUS",
          route: "/ProjectStatus",
          icon: "mdi-bookmark"
        },
        { name: "RESOURCES", route: "/Resources", icon: "mdi-cloud" },
        { name: "ABOUT US", route: "/AboutUs", icon: "mdi-note-text" }
      ],
      sideNav: false,
      userName: null,
      profilePic: null
    };
  },
  computed: {
    appLogin() {
      if (store.state.isLoggedIn) this.userData();
      return store.state.isLoggedIn;
    }
  },
  methods: {
    appLogout() {
      store.commit("logoutUser", true);
    },
    userData() {
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status) {
            this.profilePic = response.data.data.profilepic;
            this.userName = response.data.data.username;
          } else {
            store.commit("sessionOut", true);
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>

<style>
@media only screen and (min-width: 960px) and (max-width: 1060px) {
  .AppHeading {
    font-size: 12px !important;
  }
}
.nav_item {
  margin-top: 5px;
  margin-right: 20px;
}
.AppHeading {
  color: white;
  font-family: proxima;
  font-size: 16px;
  font-weight: 800 !important;
  letter-spacing: 1px !important;
}
.AppMenu {
  color: white;
  font-family: opensans;
  font-size: 12px !important;
  font-weight: 100 !important;
  text-transform: uppercase;
}

/* .navbar-fixed-top {
  margin-bottom: 0px;
  position: fixed;
}
.header {
  position: fixed;
  z-index: 1;
  width: 100%;
} */
</style>

